import i18n from "../i18n/i18n";

/**
 * Translates a validation error message if it looks like a translation key.
 * Keys are expected in the format "validation:section.key" or "validation:section.key".
 * If the message is not a translation key, returns it as-is (backward compatible).
 */
export function translateValidation(
  message: string,
  /**
   * Interpolation for keys whose sentence names something the key cannot.
   *
   * Most validation keys are complete sentences and need none. The exception is
   * a rule over a *variable* set of things — a container's route can hold any
   * number of stops, so "X is before Y" cannot have a key per pair and names
   * both ends from values instead.
   */
  values?: Record<string, unknown>,
): string {
  if (!message) return message;

  // Handle multiple validation keys joined by ", "
  const parts = message.split(", ");

  const translated = parts.map((part) => {
    const trimmed = part.trim();
    if (trimmed.startsWith("validation:")) {
      const result = i18n.t(trimmed, values);
      return result === trimmed ? trimmed : result;
    }
    return trimmed;
  });

  return translated.join(", ");
}
